<template>
  <div class="header colorHeader">
    <h2 id="title" :style="[
      !hasToken
        ? { right: '50px' }
        : isMobile
          ? {
            right: 0,
            'text-overflow': 'ellipsis',
            overflow: 'hidden',
            'text-wrap': 'nowrap',
            width: 'calc(100% - 90px)',
            display: 'block',
            'margin-right': '30px'
          }
          : { right: '330px' },
    ]">
      {{ title }}
    </h2>
    <v-btn class="home-button" color="cyan white--text" @click="goToIndex" rounded>
      <font-awesome-icon icon="home" size="lg" />
    </v-btn>
  </div>
</template>
<script>
import { getToken } from "@/utils/auth";
export default {
  computed: {
    title() {
      return this.$store.getters.headerTitle;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    hasToken() {
      return this.$store.getters.token != "" && getToken();
    },
  },
  methods: {
    goToIndex() {
      this.$store.commit("SET_DIALOG_SHOW", false);
      this.$router.push({ path: "/index" });
    },
  },
};
</script>
<style scoped>
#title {
  color: white;
  position: fixed;
  top: 20px;
  right: 100px;
  font-size: 1.2em;
}

.header {
  height: 60px;
  position: fixed;
  width: 100%;
  z-index: 2;
  padding-bottom: 5px;
  font-size: 12px;
}

.home-button {
  left: 10px;
  height: 40px !important;
  position: fixed;
  width: 40px;
  min-width: 40px !important;
  top: 10px;
}
</style>
